import { faBuilding, faCartShopping, faFileInvoiceDollar, faFilePdf, faMoneyBillTrendUp } from "@fortawesome/free-solid-svg-icons"
import MenuItem from "../../../types/menu/MenuItem"

const HTLNavListInternal: MenuItem[] = [
    {
        id: 1,
        name: 'summaryReview',
        componentName: 'Summary',
        complete: false,
        icon: faFilePdf
    },
    {
        id: 2,
        name: 'contactInfo',
        componentName: 'ContactInfo',
        complete: false,
    },
    {
        id: 3,
        name: 'incomeExpense',
        componentName: 'IncomeExpense',
        complete: false,
        icon: faMoneyBillTrendUp,
        subItems: [
            {
                id: 31,
                name: 'roomStatistics',
                componentName: 'RoomStatistics',
                complete: false
            },
            {
                id: 32,
                name: 'revenue',
                componentName: 'RevenueContainer',
                hasTabs: true,
                complete: false,
                subItems: [
                    {
                        id: 321,
                        name: 'departmentalRevenues',
                        complete: false
                    },
                    {
                        id: 322,
                        name: 'nonOperatingIncomeRevenues',
                        complete: false
                    }
                ]
            },
            {
                id: 33,
                name: 'expenses',
                hasTabs: true,
                complete: false,
                componentName: 'ExpenseContainer',
                subItems: [
                    {
                        id: 331,
                        name: 'departmentalExpenses',
                        complete: false
                    },
                    {
                        id: 332,
                        name: 'undistributedExpenses',
                        complete: false
                    },
                    {
                        id: 333,
                        name: 'managementFees',
                        complete: false
                    },
                    {
                        id: 334,
                        name: 'fixedCharges',
                        complete: false
                    },
                    {
                        id: 335,
                        name: 'nonOperatingIncomeExpenses',
                        complete: false
                    }
                ]
            },
            {
                id: 34,
                name: 'reserveForReplacementAllowance',
                complete: false,
                componentName: 'ReserveForReplacementAllowance'
            },
            {
                id: 35,
                name: 'capitalExpSummary',
                componentName: 'CapitalCostsSummary',
                complete: false
            },
            {
                id: 36,
                name: 'analysis',
                componentName: 'Analysis',
                complete: false
            }
        ],
    },
    {
        id: 4,
        name: 'apartment',
        complete: false,
        icon: faBuilding,
        subItems: [
            {
                id: 41,
                name: 'suiteBreakdownTable',
                componentName: 'SuiteBreakdown',
                complete: false
            }
        ]
    },
    {
        id: 5,
        name: 'commercial',
        complete: false,
        icon: faCartShopping,
        subItems: [
            {
                id: 51,
                name: 'leaseInformationTable',
                componentName: 'LeaseInfo',
                complete: false
            },
            {
                id: 52,
                name: 'vacantAskingRate',
                complete: false,
                componentName: 'VacantAskingRate',
            },
            {
                id: 53,
                name: 'parkingSummary',
                complete: false,
                componentName: 'ParkingPropertySummary',
            }
        ]
    },
    {
        id: 6,
        name: 'comments',
        componentName: 'Comment',
        complete: false
    },
    {
        id: 7,
        name: 'submit',
        componentName: 'Submit',
        complete: false,
        icon: faFileInvoiceDollar
    }
]

export default HTLNavListInternal